import script from "./ZoneOverviewView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZoneOverviewView.vue?vue&type=script&setup=true&lang=ts"

import "./ZoneOverviewView.vue?vue&type=style&index=0&id=0b791a6a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b791a6a"]])

export default __exports__